import React from 'react';
import { Typography, Chip } from '@mui/material';

/**
 * Payer chip template
 */
export const PayerTemplate: React.FC<{ payer?: string }> = ({ payer }) => {
  return payer ? (
    <Chip
      label={payer}
      size="small"
      sx={{ backgroundColor: '#e8f5e8', color: '#2e7d2e', maxWidth: '150px' }}
    />
  ) : (
    <Typography variant="body2" sx={{ color: '#94a3b8' }}>
      -
    </Typography>
  );
};

export default PayerTemplate;
